import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { UiTable } from '../../../../../components/ui/table/table.component';
import { ModalComponent } from '../../../../../components/modal/modal.component';
import { SelectComponent } from '../../../../../components/forms/select/select.component';
import { UiButtonComponent } from '../../../../../components/button/button.component';
import { ConfirmDialogComponent } from '../../../../../components/ui/Confirmdialog/Confirmdialog.component';
import { loaderIntervantion } from '../../../../../components/ui/loaderIntervantion/loaderIntervantion.component';
import { AppService } from '../../../../../core/app.service';
import { TypeInterventionService } from '../../../../../services/typeintervention/typeintervention.service';
import { ParametrageStructureProgrammatiqueService } from '../../../../../services/typeintervention/parametragestructureprogrammatique.service';
import { TypeInterventionResponse } from '../../../../../data/http/responses/typeintervention.response';
import { SelectOption } from '../../../../../data/schemas/selectoption.schema';
import { TableStructureProgrammatique } from '../../../../../data/schemas/table.schema';
import { ParametrageStructureProgrammatiqueResponse } from '../../../../../data/http/responses/parametragestructureprogrammatique.response';
import { ParametrageStructureProgrammatiqueRequest } from '../../../../../data/http/requests/parametragestructureprogrammatique.request';

@Component({
  selector: 'app-structureprogrammatique',
  imports: [UiTable, ModalComponent, SelectComponent, UiButtonComponent, ConfirmDialogComponent, loaderIntervantion, ReactiveFormsModule],
  templateUrl: './structureprogrammatique.component.html',
  styleUrl: './structureprogrammatique.component.css'
})
export class StructureprogrammatiqueComponent implements OnInit {
  public tableStructureProgrammatique = TableStructureProgrammatique;
  public configurations: ParametrageStructureProgrammatiqueResponse[] = [];
  public typeInterventionOptions: SelectOption[] = [];
  public isLoading = false;
  public isEditing = false;
  public showModal = false;
  public showDeleteConfirm = false;
  public deleteLoading = false;
  public selectedItem: ParametrageStructureProgrammatiqueResponse | null = null;
  public editingItem: ParametrageStructureProgrammatiqueResponse | null = null;
  public form: FormGroup;

  private readonly reference = 'STRUCTURE_PROGRAMMATIQUE';
  private readonly typeCode = 'TYPE_ACTIVITE';

  constructor(
    private parametrageService: ParametrageStructureProgrammatiqueService,
    private typeInterventionService: TypeInterventionService,
    private fb: FormBuilder,
    private appService: AppService
  ) {
    this.form = this.fb.group({ valeur: ['', Validators.required] });
  }

  ngOnInit(): void {
    this.loadTypeInterventions();
    this.loadConfigurations();
  }

  loadTypeInterventions(): void {
    this.typeInterventionService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        const items: TypeInterventionResponse[] = response.data || [];
        this.typeInterventionOptions = items.map(item => ({ value: item.id, label: item.libelle }));
        this.configurations = this.configurations.map(item => ({
          ...item,
          typeCode: this.typeInterventionOptions.find(option => option.value === item.valeur)?.value,
          typeInterventionLibelle: this.typeInterventionOptions.find(option => option.value === item.valeur)?.label
        }));
      },
      error: error => console.error('Erreur lors du chargement des types d’intervention :', error)
    });
  }

  loadConfigurations(): void {
    this.isLoading = true;
    this.parametrageService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        const items: ParametrageStructureProgrammatiqueResponse[] = response.data || [];
        this.configurations = items.filter(item => item.reference === this.reference);
        this.isLoading = false;
      },
      error: error => {
        console.error('Erreur lors du chargement du paramétrage :', error);
        this.isLoading = false;
      }
    });
  }

  openModal(): void {
    this.isEditing = false;
    this.editingItem = null;
    this.form.reset({ valeur: '' });
    this.showModal = true;
  }

  closeModal(): void {
    this.showModal = false;
    this.isEditing = false;
    this.editingItem = null;
    this.form.reset({ valeur: '' });
  }

  edit(item: ParametrageStructureProgrammatiqueResponse): void {
    this.isEditing = true;
    this.editingItem = item;
    this.form.patchValue({ valeur: item.valeur });
    this.showModal = true;
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const applicationId = this.appService.getAppId();
    if (!applicationId || applicationId === 'null') return;

    const request: ParametrageStructureProgrammatiqueRequest = {
      reference: this.reference,
      libelle: 'Début des activités',
      valeur: this.form.value.valeur,
      typeCode: this.typeCode,
      applicationId
    };

    this.isLoading = true;
    const operation = this.isEditing && this.editingItem
      ? this.parametrageService.update(this.editingItem.id, request)
      : this.parametrageService.create(request);

    operation.subscribe({
      next: () => {
        this.closeModal();
        this.loadConfigurations();
      },
      error: error => {
        console.error('Erreur lors de l’enregistrement du paramétrage :', error);
        this.isLoading = false;
      }
    });
  }

  openDeleteConfirm(item: ParametrageStructureProgrammatiqueResponse): void {
    this.selectedItem = item;
    this.showDeleteConfirm = true;
  }

  cancelDelete(): void {
    this.showDeleteConfirm = false;
    this.selectedItem = null;
  }

  confirmDelete(): void {
    if (!this.selectedItem) return;
    this.deleteLoading = true;
    this.parametrageService.delete(this.selectedItem.id).subscribe({
      next: () => {
        this.cancelDelete();
        this.loadConfigurations();
        this.deleteLoading = false;
      },
      error: error => {
        console.error('Erreur lors de la suppression du paramétrage :', error);
        this.deleteLoading = false;
      }
    });
  }

}
